import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { recordCountsLabelSx } from './UserLotListsPanel/UserLotListsPanel.styles';

/**
 * Totales del toolbar (Registros, detalle de lista, Resultados, Historial). Una sola
 * línea: si no entra junto al orden, se corta con «…» y el texto completo va en el
 * tooltip. Con `tooltip` (p. ej. el desglose «2128 lotes · 929 unidades · 12 con
 * contenido de lote» de `formatRecordsSummary`) el tooltip muestra ese texto; el
 * label sigue siendo el nombre accesible y el tooltip, su descripción.
 * Con `wrap` no se corta: la fila del toolbar baja el orden y la vista a la
 * línea siguiente (`recordCountsWrapRowSx`).
 */
export default function RecordCountsLabel({ children, tooltip = null, wrap = false }) {
  const text = String(children ?? '');
  if (wrap) {
    return (
      <Typography
        data-testid="record-counts-label"
        sx={{ ...recordCountsLabelSx, flex: '1 0 auto', whiteSpace: 'nowrap' }}
      >
        {text}
      </Typography>
    );
  }
  return (
    <Tooltip
      title={tooltip || text}
      placement="top"
      arrow
      enterDelay={300}
      describeChild={Boolean(tooltip) && tooltip !== text}
    >
      <Typography
        data-testid="record-counts-label"
        data-tooltip={tooltip || undefined}
        sx={{
          ...recordCountsLabelSx,
          flex: '1 1 auto',
          minWidth: 0,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {text}
      </Typography>
    </Tooltip>
  );
}
